import styled from 'styled-components';
import * as Buttons from '../../../styles/lib/buttons';
import * as Grid from '../../../styles/lib/grid';
import * as Input from '../../../styles/lib/input';

export { Buttons, Grid, Input };

export const AddButton = styled(Buttons.Button)`
  min-height: 40px;
  img {
    margin-right: 5px;
  }
  @media (max-width: 768px) {
    margin-top: 3px;
  }
`;

export const RowContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 2%;

  & > * {
    flex: 1;
  }

  & > :first-child {
    flex: 4;
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

export const Text = styled.div`
  width: 100%;
  margin: 0;

  &.extended {
    width: 100%;
    max-width: 350px;
    color: #033b71;
  }

  &.bold {
    font-weight: 700;
  }

  &.top-margin {
    margin: 16px 0 8px;
  }

  &.inline {
    display: inline;
  }

  &.small-danger {
    font-size: 12px;
    color: red;
    margin-top: 1%;
  }

  @media (max-width: 768px) {
    font-size: 12px;
  }

  &.small {
    font-size: 13px;
  }
`;

export const FormPermission = styled.form`
  @media (min-width: 768px) {
    .form-control {
      padding: 16px 0;
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      row-gap: 16px;
      column-gap: 10%;
      label {
        width: 100%;
        font-size: 14px;
        display: flex;
        align-items: center;

        input {
          margin-right: 4px;
        }
      }
    }
  }
`;

export const ToggleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 28px;
  margin-bottom: 16px;
  padding: 14px 16px;
  background-color: #f9f9f9;
  border: 1px solid #eef0f2;
  border-radius: 12px;
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #f5f7f9;
    border-color: #e2e5e8;
  }
`;

export const ToggleLabel = styled.label`
  font-size: 14px;
  font-weight: 500;
  color: #51515c;
  cursor: pointer;
  user-select: none;
`;

export const Switch = styled.label`
  position: relative;
  display: inline-block;
  width: 44px;
  height: 22px;
  flex-shrink: 0;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }
`;

export const Slider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #dadada;
  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 22px;

  &:before {
    position: absolute;
    content: '';
    height: 14px;
    width: 14px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    border-radius: 50%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  }

  input:checked + & {
    background-color: #033b71;
  }

  input:checked + &:before {
    transform: translateX(22px);
  }
`;
